export enum PaymentOptions {
  CreditCard = 'CREDIT_CARD',
  Invoice = 'INVOICE',
  Bulk = 'BULK_CREDITS',
  ServiceProject = 'SERVICE_PROJECT',
}
